import axiosInstance from "src/common/axiosInstance";

/* GET /workspaces */
export async function getWorkspaces() {
  const response = await axiosInstance.get("/workspaces");
  return response.data?.data || [];
}

/* GET /workspaces/{workspaceId} */
export async function getWorkspace(workspaceId) {
  const response = await axiosInstance.get(`/workspaces/${workspaceId}`);
  return response.data?.data || null;
}

/* GET /workspaces/{workspaceId}/overview */
export async function getWorkspaceOverview(workspaceId) {
  const response = await axiosInstance.get(`/workspaces/${workspaceId}/overview`);
  return response.data?.data || null;
}

/* POST /workspace */
export async function createWorkspace(payload) {
  const response = await axiosInstance.post("/workspaces", payload);
  return response.data?.data || null;
}

/* PUT /workspaces/{workspaceId} */
export async function updateWorkspace(workspaceId, payload) {
  const response = await axiosInstance.put(`/workspaces/${workspaceId}`, payload);
  return response.data?.data || null;
}

/**
 * Normalizes any axios/error object into a user-safe message. */
export function getErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  return error?.response?.data?.message || fallback;
}

/* Builds the exact payload the backend expects for create/update */
export function toWorkspacePayload(form) {
  return {
    name: form.name?.trim() || "",
    legal_name: form.legal_name?.trim() || "",
    email: form.email?.trim() || "",
    phone: form.phone?.trim() || "",
    website: form.website?.trim() || "",
    industry: form.industry?.trim() || "",
    company_size: form.company_size?.trim() || "",
    country: form.country?.trim() || "",
    timezone: form.timezone?.trim() || "",
    currency: form.currency?.trim().toUpperCase() || "",
    logo_url: form.logo_url?.trim() || null,
  };
}
